// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"TransporterCard_cardWrapper___l2W5"};